/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithWrapper_shoppingWith = {
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithHeading_shoppingWith" | "ShoppingWithTopModule_shoppingWith" | "ShoppingWithGrid_shoppingWith">;
    readonly " $refType": "ShoppingWithWrapper_shoppingWith";
};
export type ShoppingWithWrapper_shoppingWith$data = ShoppingWithWrapper_shoppingWith;
export type ShoppingWithWrapper_shoppingWith$key = {
    readonly " $data"?: ShoppingWithWrapper_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithWrapper_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithWrapper_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithHeading_shoppingWith",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithTopModule_shoppingWith",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithGrid_shoppingWith",
      "args": null
    }
  ]
};
(node as any).hash = '4161980a5a5eb3624da42d8647393d62';
export default node;
